const statusStyles = {
  queued: "bg-yellow-100 text-yellow-800",
  processing: "bg-blue-100 text-blue-800",
  completed: "bg-green-100 text-green-800",
  failed: "bg-red-100 text-red-800",
  expired: "bg-gray-100 text-gray-700",
};

function displayDate(value) {
  if (!value) return "—";
  return new Date(value).toLocaleString();
}

export default function RecentReports({ reports, loading, onDownload, onRetry }) {
  return (
    <div className="mt-6 px-4 sm:px-6 lg:px-8">
      <div className="card-custom px-4 py-5 sm:px-6">
        <div className="mb-4">
          <h2 className="text-base font-semibold text-gray-900">Recent reports</h2>
          <p className="text-sm text-gray-500">
            Reports and their selected parameters remain available for 24 hours.
          </p>
        </div>

        {loading ? (
          <p className="text-sm text-gray-500">Loading recent reports…</p>
        ) : reports.length === 0 ? (
          <p className="text-sm text-gray-500">No reports have been requested in the last 24 hours.</p>
        ) : (
          <div className="space-y-3">
            {reports.map((report) => (
              <details key={report.id} className="rounded-md border border-gray-200 bg-white p-4">
                <summary className="cursor-pointer list-none">
                  <div className="flex flex-col gap-3 sm:flex-row sm:items-center sm:justify-between">
                    <div>
                      <p className="font-semibold text-gray-900">{report.report_name}</p>
                      <p className="text-xs text-gray-500">Requested {displayDate(report.requested_at)}</p>
                    </div>
                    <div className="flex flex-wrap items-center gap-2">
                      <span className={`rounded-full px-2.5 py-1 text-xs font-semibold ${statusStyles[report.status] || "bg-gray-100 text-gray-700"}`}>
                        {report.status}
                      </span>
                      {report.download_url && (
                        <button
                          type="button"
                          className="rounded-md bg-main-purple px-3 py-1.5 text-xs font-semibold text-white"
                          onClick={(event) => {
                            event.preventDefault();
                            onDownload(report);
                          }}
                        >
                          Download
                        </button>
                      )}
                      {report.can_retry && (
                        <button
                          type="button"
                          className="rounded-md border border-main-purple px-3 py-1.5 text-xs font-semibold main-purple"
                          onClick={(event) => {
                            event.preventDefault();
                            onRetry(report);
                          }}
                        >
                          Generate again
                        </button>
                      )}
                    </div>
                  </div>
                </summary>

                <div className="mt-4 border-t border-gray-100 pt-3">
                  <dl className="grid grid-cols-1 gap-x-6 gap-y-2 sm:grid-cols-2 lg:grid-cols-3">
                    {Object.entries(report.parameter_labels || {}).map(([label, value]) => (
                      <div key={label}>
                        <dt className="text-xs font-medium text-gray-500">{label}</dt>
                        <dd className="text-sm text-gray-900">{String(value)}</dd>
                      </div>
                    ))}
                    <div>
                      <dt className="text-xs font-medium text-gray-500">Expires</dt>
                      <dd className="text-sm text-gray-900">{displayDate(report.expires_at)}</dd>
                    </div>
                  </dl>
                  {report.progress_message && <p className="mt-3 text-sm text-gray-600">{report.progress_message}</p>}
                  {report.error_message && <p className="mt-2 text-sm text-red-600">{report.error_message}</p>}
                </div>
              </details>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}
